// frontend/src/services/comments.ts

import api from "./api";

export interface Reply {
  id: number;
  author: string;
  text: string;
  timestamp: string;
}

export interface Comment {
  id: number;
  document_id: number;
  user_id: number;
  content: string;
  title?: string;
  created_at: string;
  parent_id?: number;
  username: string;
  nome: string;
  cognome: string;
  replies: Reply[];
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error?: {
    code: string;
    message: string;
  };
}

export const getComments = async (
  documentIds: number[]
): Promise<ApiResponse<Comment[]>> => {
  try {
    const response = await api.get<ApiResponse<Comment[]>>("/comments", {
      params: { documentIds },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createComment = async (
  documentId: number,
  data: { content: string; title?: string }
): Promise<ApiResponse<Comment>> => {
  try {
    const response = await api.post<ApiResponse<Comment>>(
      `/comments/document/${documentId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createReply = async (
  parentId: number,
  data: { content: string }
): Promise<ApiResponse<Comment>> => {
  try {
    const response = await api.post<ApiResponse<Comment>>(
      `/comments/${parentId}/replies`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
